module.exports = __webpack_public_path__ + "img/workContents06-05.ced2ab47.png";